import React, { Component } from 'react';
import ButtonSelectDropdown from 'Components/Elements/Buttons/ButtonSelectDropdown';
import { IFilterOption } from 'core/redux/features/shared/types';
import { connect } from 'react-redux';
import { AppState } from 'core/redux/reducers';
import { selectTranslator, TransFn } from 'core/redux/features/languages/trans';

interface PropTypes {
  options: Array<IFilterOption<any>>;
  name: string;
  selected: IFilterOption<any>;
  onSelect: (e: React.SyntheticEvent, item: IFilterOption<any>) => void;
  isActive?: boolean;
  deviceType: string;
  children?: React.ReactNode;
  className?: string;
  activeOnHover?: boolean;
  trans: TransFn;
  iosIviFix?: boolean;
}

class FilterSelect extends Component<PropTypes> {
  render() {
    // controlMobile={true}
    return (
      <ButtonSelectDropdown
        controlMobile={this.props.deviceType === 'mobile'}
        {...this.props}
      />
    );
  }
}

const configure = connect((state: AppState) => ({
  deviceType: state.deviceType,
  trans: selectTranslator(state),
}))(FilterSelect);
export default configure;
